import axios from 'axios';

const client = axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});
client.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
client.defaults.xsrfCookieName = 'csrftoken';

export default client;
